/**
  不会出现在菜单中的基本路由
  wk 2019-11-29
*/

import Main from "../views/Main";

const otherRouters = {
  path: "/",
  name: "otherRouters",
  component: Main,
  children: [
    {
      path: "/pileStationDetail",
      name: "pileStationDetail",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () =>
        import("../views/charging-manage/pile-station/detail.vue"),
    },
    {
      path: "/reportDetail",
      name: "reportDetail",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () =>
        import("../views/charging-manage/pile-station/report-detail.vue"),
    },
    {
      path: "/postageDetail",
      name: "postageDetail",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () =>
        import("../views/charging-manage/pile-station/postage-detail.vue"),
    },
    {
      path: "/settlementDetail",
      name: "settlementDetail",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () =>
        import("../views/charging-manage/pile-station/settlement-detail.vue"),
    },
    {
      path: "/Distribution",
      name: "Distribution",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () => import("../views/charging-manage/pile-station/Distribution.vue"),
    },
    {
      path: "/meter",
      name: "meter",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () => import("../views/charging-manage/pile-station/meter.vue"),
    },
    {
      path: "/contract",
      name: "contract",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () => import("../views/charging-manage/pile-station/contract.vue"),
    },
    {
      path: "/seatFee",
      name: "seatFee",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () => import("../views/charging-manage/pile-station/seat-fee.vue"),
    },
    {
      path: "/energyStorageDetail",
      name: "energyStorageDetail",
      meta: {
        parent: ["chargeManage", "pileStationList"],
        current: ["pileStationList"],
      },
      component: () => import("../views/charging-manage/pile-station/energy-storage-detail.vue"),
    },
    {
      path: "/pileModelDetail",
      name: "pileModelDetail",
      meta: {
        parent: ["chargeManage", "pileModelList"],
        current: ["pileModelList"],
      },
      component: () => import("../views/charging-manage/pile-model/detail.vue"),
    },

    // {
    // 	path: '/pileDetailTab/:id',
    // 	name: 'pileDetailTab',
    // 	meta:{
    // 		parent: ['chargeManage','pileList'],
    // 		current: ['pileList'],
    // 	},
    // 	component: () => import('../views/charging-manage/pile/detail.vue')
    // },
    {
      path: "/pileDetail",
      name: "pileDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/pile-detail.vue"),
    },

    {
      path: "/repairDetail/:id",
      name: "repairDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/repair-detail.vue"),
    },
    {
      path: "/repairAddDetail",
      name: "repairAddDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/repair-add-detail.vue"),
    },
    {
      path: "/pileReportDetail",
      name: "pileReportDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/report-detail.vue"),
    },
    {
      path: "/pileChargeDetail",
      name: "pileChargeDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/charge-detail.vue"),
    },
    {
      path: "/repairListDetail",
      name: "repairListDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/repair-list.vue"),
    },
    {
      path: "/faultDetail",
      name: "faultDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/fault-detail.vue"),
    },
    {
      path: "/operationDetail",
      name: "operationDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/operation-detail.vue"),
    },
    {
      path: "/ZDBoxDetail",
      name: "ZDBoxDetail",
      meta: {
        parent: ["chargeManage", "ZDBoxManage"],
        current: ["ZDBoxManage"],
      },
      component: () => import("../views/charging-manage/zd-box-manage/detail.vue"),
    },
    {
      path: "/ZDBoxModelDetail",
      name: "ZDBoxModelDetail",
      meta: {
        parent: ["chargeManage", "ZDBoxModelManage"],
        current: ["ZDBoxModelManage"],
      },
      component: () => import("../views/charging-manage/zd-box-model-manage/detail.vue"),
    },
    {
      path: "/custDetail",
      name: "custDetail",
      meta: {
        parent: ["custManage", "custManageList"],
        current: ["custManageList"],
      },
      component: () => import("../views/cust-manage/cust-detail.vue"),
    },
    {
      path: "/accountStatementDetail", // 账户流水列表
      name: "accountStatementDetail",
      meta: {
        parent: ["custManage", "custManageList"],
        current: ["custManageList"],
      },
      component: () => import("../views/cust-manage/account-statement-detail.vue"),
    },
    {
      path: "/setSiteDiscountRate",
      name: "setSiteDiscountRate",
      meta: {
        parent: ["custManage", "SiteDiscountRate"],
        current: ["SiteDiscountRate"],
      },
      component: () => import("../views/cust-manage/SiteDiscountRate/setSiteDiscountRate.vue"),
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      meta: {
        parent: ["orderManage", "orderManageList"],
        current: ["orderManageList"],
      },
      component: () => import("../views/order-manage/detail.vue"),
    },
    {
      path: "/dealerDetail",
      name: "dealerDetail",
      meta: {
        parent: ["dealerManage", "dealerManageList"],
        current: ["dealerManageList"],
      },
      component: () => import("../views/dealer-manage/detail.vue"),
    },
    {
      path: "/dealerReportDetail",
      name: "dealerReportDetail",
      meta: {
        parent: ["dealerManage", "dealerManageList"],
        current: ["dealerManageList"],
      },
      component: () => import("../views/dealer-manage/report-detail.vue"),
    },
    {
      path: "/accountsReviewDetail",
      name: "accountsReviewDetail",
      meta: {
        parent: ["financeManage", "accountsReviewList"],
        current: ["accountsReviewList"],
      },
      component: () =>
        import("../views/finance-manage/accounts-review/detail.vue"),
    },
    {
      path: "/financeReviewDetail",
      name: "financeReviewDetail",
      meta: {
        parent: ["financeManage", "financeReviewList"],
        current: ["financeReviewList"],
      },
      component: () =>
        import("../views/finance-manage/finance-review/detail.vue"),
    },
    {
      path: "/InvoicingDetail",
      name: "InvoicingDetail",
      meta: {
        parent: ["financeManage", "InvoicingManagement"],
        current: ["InvoicingManagement"],
      },
      component: () =>
        import("../views/finance-manage/Invoicing-management/detail.vue"),
    },
    {
      path: "/serviceRecordDetail",
      name: "serviceRecordDetail",
      meta: {
        parent: ["serviceRecord", "serviceRecordList"],
        current: ["serviceRecordList"],
      },
      component: () => import("../views/service-record/detail.vue"),
    },
    {
      path: "/userManageDetail",
      name: "userManageDetail",
      meta: {
        parent: ["systemManage", "userManageList"],
        current: ["userManageDetail"],
      },
      component: () => import("../views/system-manage/user-manage/detail.vue"),
    },
    {
      path: "/roleManageDetail",
      name: "roleManageDetail",
      meta: {
        parent: ["systemManage", "roleManageList"],
        current: ["roleManageDetail"],
      },
      component: () => import("../views/system-manage/role-manage/detail.vue"),
    },
    {
      path: "/charginglogDetail",
      name: "charginglogDetail",
      meta: {
        parent: ["systemManage", "charginglogList"],
        current: ["charginglogDetail"],
      },
      component: () => import("../views/system-manage/charging-log/detail.vue"),
    },
    {
      path: "/noticeDetail",
      name: "noticeDetail",
      meta: {
        parent: ["mobileManage", "noticeList"],
        current: ["noticeDetail"],
      },
      component: () => import("../views/mobile-manage/notice/detail.vue"),
    },
    {
      path: "/openScreenDetail",
      name: "openScreenDetail",
      meta: {
        parent: ["mobileManage", "openScreenList"],
        current: ["openScreenDetail"],
      },
      component: () => import("../views/mobile-manage/open-screen/detail.vue"),
    },
    {
      path: "/bannerDetail",
      name: "bannerDetail",
      meta: {
        parent: ["mobileManage", "bannerList"],
        current: ["bannerDetail"],
      },
      component: () => import("../views/mobile-manage/banner/detail.vue"),
    },
    {
      path: "/activityDetail",
      name: "activityDetail",
      meta: {
        parent: ["activity", "activityManagement"],
        current: ["activityDetail"],
      },
      component: () => import("../views/service-activity/detial.vue"),
    },
    {
      path: "/activityPreview",
      name: "activityPreview",
      meta: {
        parent: ["activity", "activityManagement"],
        current: ["activityPreview"],
      },
      component: () => import("../views/service-activity/preview.vue"),
    },

    {
      path: "/commodityDetial",
      name: "commodityDetial",
      meta: {
        parent: ["commodity", "commodityList"],
        current: ["commodityDetial"],
      },
      component: () => import("../views/commodity-list/detial.vue"),
    },
  ],
};

export default otherRouters;
